import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";

import { useNotificationActions } from "~/shared/hooks/use-notifications.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { deleteAndValidateTraxAr } from "~/shared/services/api/fetch-client.ts";

const deleteExistingRoutingGuide = async (id: number) => {
	const url = apiRoutes.PUTGLOBALROUTINGGUIDE.replace(":id", id.toString());
	const response = await deleteAndValidateTraxAr(url, z.unknown());
	if (!response.success) {
		throw new Error(
			`Failed to create routing guide: ${response.error}`,
			response.details instanceof Error
				? { cause: response.details }
				: undefined,
		);
	}
	return response.data;
};

export const useDeleteRoutingGuide = () => {
	const queryClient = useQueryClient();
	const { showError, showSuccess } = useNotificationActions();

	const { mutate: deleteRoutingGuide } = useMutation({
		mutationFn: (id: number) => deleteExistingRoutingGuide(id),

		onSuccess: () => {
			showSuccess("Routing Guide Deleted");
			void queryClient.invalidateQueries({ queryKey: ["globalRoutingGuides"] });
			void queryClient.invalidateQueries({
				queryKey: ["customerRoutingGuides"],
			});
		},

		onError: (_err) => {
			showError(`${_err}`);
		},
	});

	return { deleteRoutingGuide };
};
